// frontend/src/components/landing/CTA.jsx
import Button from "../common/Button";
import { ArrowRightIcon } from "../common/Icon";
import "./CTA.css";

/** Closing call-to-action band. onStart: primary action. */
export default function CTA({ onStart, startLabel = "Start building" }) {
  return (
    <section className="cta-band" aria-labelledby="cta-title">
      <div className="container cta-band__inner">
        <h2 id="cta-title" className="cta-band__title">
          Your next prompt deserves <em>a better question.</em>
        </h2>
        <div className="cta-band__side">
          <Button variant="primary" size="lg" onClick={onStart} iconRight={<ArrowRightIcon size={18} />}>
            {startLabel}
          </Button>
          <p className="cta-band__note">Closed research preview. Sign-up needs an access code.</p>
        </div>
      </div>
    </section>
  );
}
